<h2>Création de contenu pilot-info</h2>
<div class="container">
  <div class="mt-2 value-container">
    <div sm="10" class="mt-5">
      <textarea [(ngModel)]="value" placeholder="Insérer la valeur" rows="12" cols="75"></textarea>
    </div>
  </div>

  <div class="w-100 d-flex mt-4 justify-content-center pilot-info-selects">
    <mat-form-field class="view-filter mr-3 w-auto" style="height: 45px">
      <mat-label>Concession</mat-label>
      <mat-select [(ngModel)]="dealership" [disabled]="elementId != 0"  appearance="fill">
        <mat-option>
          <input id="select-search-dealership" class="form-control select-input custom-search-input" (click)="$event.stopPropagation()" (keyup)="filterDealership($event)" type="text" placeholder="Recherche">
        </mat-option>
        <mat-option *ngFor="let dealership of dealershipArray"  [value]="dealership.concession_id">
          {{dealership.nom_concession}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="view-filter ml-3 w-auto" style="height: 45px">
      <mat-label>Marque</mat-label>
      <mat-select [(ngModel)]="brand"  appearance="fill">
        <mat-option *ngFor="let brand of brandArray"  [value]="brand.nom">
          {{brand.nom}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="date mt-4">
  <div class="pilot-info-dates">
    <div style="width: 310px;">
      <mat-form-field class="w-100 pr-3" appearance="fill" style="flex: 1">
        <mat-label>Date de Début</mat-label>
        <input matInput [(ngModel)]="startAt" [matDatepicker]="picker1" [disabled]="elementId && startAt <= dateNow">
        <mat-datepicker-toggle matSuffix [for]="picker1" [disabled]="elementId && startAt <= dateNow"></mat-datepicker-toggle>
        <mat-datepicker #picker1 disabled="false"></mat-datepicker>
      </mat-form-field>
    </div>

    <div style="width: 310px;">
      <mat-form-field class="w-100 pl-3" appearance="fill" style="flex: 1">
        <mat-label>Date de Fin</mat-label>
        <input matInput [(ngModel)]="endAt" [matDatepicker]="picker2">
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2 disabled="false"></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
</div>

<div class="d-flex justify-content-center">
  <div class="mb-3">
    <input #uploadImageInput hidden="true" type="file" onclick="this.value=null"
           (change)="uploadImage($event)" accept="image"/>
    <div class="d-flex justify-content-center align-items-center">
      <button *ngIf="contentSrc == ''" matTooltip="Importer une image" type="button" id="btn-import-table" class="ml-4 mt-3 btn btn-outline-dark" (click)="uploadImageInput.click()">
        Importer une image
      </button>
      <button *ngIf="contentSrc != ''" matTooltip="Supprimer image" type="button" class="ml-4 mt-3 btn btn-outline-danger" (click)="deleteImage(this.elementId)">
        Supprimer l'image
      </button>
    </div>
    <div class="ml-5 d-flex flex-column align-items-center">
      <small class="text-info">Taille max : 5mb</small>
      <div class="file-name mt-2">{{fileNameFullsize}}</div>
      <div style="display: inline-grid">
        <img *ngIf="contentSrc != ''" src="{{contentSrc}}" alt="image" width="300" class="fullscreen-image m-auto">
      </div>
    </div>
  </div>
</div>


<div class="btn-group w-100 d-flex justify-content-center mt-4">
  <small class="text-danger">{{errorMessage}}</small>
</div>
<div class="btn-group w-100 d-flex justify-content-center mt-4">
  <div>
    <button (click)="onCreate()" class="btn btn-dark btn100px p-2 mr-2" [disabled]="onValidation()">{{ elementId ? 'Modifier' : 'Créer' }}</button>
  </div>
  <div>
    <button (click)="onCancel()" class="btn btn-light border-dark btn100px p-2">Annuler</button>
  </div>
</div>
